import { forwardRef } from "react";
import { Link as RouterLink, LinkProps as RouterLinkProps } from "react-router-dom";

import { PrefetchConfig, PrefetchHandler } from "@/domain/_shared/preloader/components/prefetch-handler";
import { cn } from "@/lib/cn";

interface LinkProps extends RouterLinkProps {
  prefetchConfig?: Omit<PrefetchConfig, "to">;
  replace?: boolean;
}

export const Link = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ prefetchConfig, replace = false, onClick, ...props }, ref) => {
    return (
      <PrefetchHandler prefetchConfig={{ ...prefetchConfig, to: props.to.toString() }}>
        <RouterLink
          ref={ref}
          {...props}
          className={cn("my-1 focus-visible:outline-2 focus-visible:outline-offset-0 focus-visible:outline-focus", props.className)}
          replace={replace}
          onClick={onClick}
        />
      </PrefetchHandler>
    );
  },
);

Link.displayName = "Link";
